<template>
	<div class="storekeeper">
		<div class="btnbox">
			<el-page-header @back="goBack" content="进销存">
			</el-page-header>
		</div>

		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0px"
					v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="订单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.style_number" placeholder="款号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.size_id" placeholder="尺码" filterable>
							<el-option label="尺码" value="">
							</el-option>
							<el-option :label="v.name" :value="v.name" v-for="(v,k) in appdata.list.product_size"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.ctype" placeholder="类型">
							<el-option label="类型" value="">
							</el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.shop_stock_ctype"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>

			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="trade_no" label="订单号" fixed="left" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="product_brand" label="品牌" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="product_style_number" label="款号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="product_size" label="尺码" align="center" header-align="center" min-width="40px">
					</el-table-column>
					<el-table-column prop="stock" label="数量变化" align="center" header-align="center" min-width="50px">
					</el-table-column>
					<el-table-column prop="after_stock" label="库存结余" align="center" header-align="center" min-width="50px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="时间" width="100px" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="ctype_str" label="类型" fixed="right" align="center" header-align="center" min-width="60px">
					</el-table-column>
				</el-table>
			</div>

			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'storekeeper',
		data() {
			return {
				list: [],
				formfilter: {
					id: "",
					shop_id: Number(this.$route.query.id),
					trade_no: "",
					size_id: "",
					style_number: "",
					brand: "",
					ctype: "",
				},
				filtershow: true,
				value1: [],
				page: 1,
				pageSize: 10,
				total: 0,
			}
		},

		inject: ['appdata'],

		mounted() {
			this.loadlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height)+30;
					if(this.$refs.tablediv) {
						this.$refs.tablediv.style.height = "calc(100% - "+num+"px)";
					}
				}
			});
			this.$nextTick(()=>{
				this.resizeObserver.observe(this.$refs.filter);
			})
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			loadlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				if (this.value1.length != 0) {
					obj.btime = this.value1[0];
					obj.etime = this.value1[1];
				} else {
					obj.btime = "";
					obj.etime = "";
				}

				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/shop_stock_log_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			goBack() {
				this.$router.go(-1);
			},

			handleCurrentChange() {
				this.loadlist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.loadlist();
			},

			onfilter() {
				this.page = 1;
				this.loadlist();
			},
			onreset() {
				this.formfilter.trade_no = "";
				this.formfilter.size_id = "";
				this.formfilter.style_number = "";
				this.formfilter.brand = "";
				this.formfilter.ctype = "";
				this.value1 = [];
				this.page = 1;
				this.loadlist();
			}
		}
	}
</script>

<style scoped lang="less">
	.storekeeper {
		height: 100%;
	}
	.btnbox {
		justify-content: flex-start;
	}
	.tablebox {
		height: calc(100% - 72px);
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/storekeeper.vue